import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MentionableUser } from '@ps/survey-utils';

export const MentionableUsersActions = createActionGroup({
  source: 'Mentionable Users',
  events: {
    'Load Mentionable Users': emptyProps(),
  },
});

export const MentionableUsersApiActions = createActionGroup({
  source: 'Mentionable Users API',
  events: {
    'Load Mentionable Users Success': props<{
      users: MentionableUser[];
      cachedAt: number;
    }>(),
  },
});
